import React from 'react';
import SalesCallout from './SalesCallout';

interface SalesCalloutHTOProps {
  ctaPageName: string;
}

type Props = React.FC<React.HTMLAttributes<HTMLAnchorElement> & SalesCalloutHTOProps>;

const SalesCalloutHTO: Props = ({ className, ctaPageName, ...props }) => {
  return (
    <SalesCallout
      title="Free Home Try-on."
      ctaTitle="Start Try-on"
      calloutId="sales_callout_home_try_on"
      ctaPageName={ctaPageName}
      href="/home-try-on"
      {...props}
      className={`${className ? className : ''}`}
      image={
        <div className="inline-block max-w-full">
          <picture>
            <img
              className="block h-auto max-w-full align-middle"
              width={240}
              height={210}
              loading="lazy"
              src="https://gentux.imgix.net/1616761883_170606box0085blacktux210326083102.png?w=240&auto=format&dpr=2"
              alt="Generation Tux shipping box"
            />
          </picture>
        </div>
      }
    >
      You won’t find this in stores. Ensure the right fit with a free home try‑on.
    </SalesCallout>
  );
};

export default SalesCalloutHTO;
